<template lang="pug">
  .popup-dispatcher
    template(v-for="popup in items")
      template(v-if="popup && popup.component")
        DrawerWrapper(v-if="popup.drawer" ref="popup")
        PopupWrapper(v-else-if="popup.wrappable" ref="popup")
        component(v-else :is="popup.component" ref="popup")
</template>

<script>
import model from '@/model/popup';
import PopupWrapper from '@/components/popup/PopupWrapper.vue';
import DrawerWrapper from '@/components/popup/DrawerWrapper.vue';

export default {
  name: 'PopupDispatcher',
  components: { PopupWrapper, DrawerWrapper },
  handledPopups: [],
  computed: {
    items() { return this.$store.state.popup.items; },
  },
  watch: {
    items() {
      this.items.forEach((p, i) => {
        if (this.$options.handledPopups.includes(p)) return;

        this.$nextTick(() => {
          const ref = this.$refs.popup[i];

          // drawer подразумевает wrappable: у обёрток шторки и попапа один и
          // тот же open(descriptor)
          (p.wrappable || p.drawer ? ref.open(p) : ref.open(...(p.args ?? [])))
            .then(r => { model.resolve(p, r); });
          this.$options.handledPopups.push(p);
        });
      });
    },
  },
  methods: {},
};
</script>

<style scoped>

</style>
